import { API_URL } from "@/config/constants";
import { buildUrl } from "@/utils/buildUrl";
import axios from "axios";
import { IFilter, Page } from "../api.types";
import {
    ITopic,
    ITopicClause,
    ITopicClauseBulkCreate,
    ITopicClauseBulkCreateResponse,
    ITopicClauseCreate,
    ITopicClauseFilter,
    ITopicCreate,
    ITopicDetail,
    ITopicImportStats,
    ITopicList,
    ITopicUpdate,
} from "./topics.types";

const API = `${API_URL}/topics`;

// --- Topic CRUD ---

export const createTopic = async (topicCreate: ITopicCreate) => {
    const result = await axios.post<ITopic>(API, topicCreate);
    return result.data;
};

export const getTopics = async (
    page: number = 1,
    size: number = 50,
    filter?: IFilter,
    search?: string | null
) => {
    const url = buildUrl(API, { page, size, search, ...filter });
    const result = await axios.get<Page<ITopicList>>(url);
    return result.data;
};

export const getTopic = async (id: number) => {
    const result = await axios.get<ITopicDetail>(`${API}/${id}`);
    return result.data;
};

export const updateTopic = async (id: number, topicUpdate: ITopicUpdate) => {
    const result = await axios.put<ITopic>(`${API}/${id}`, topicUpdate);
    return result.data;
};

export const deleteTopic = async (id: number) => {
    const result = await axios.delete(`${API}/${id}`);
    return result.data;
};

// --- Topic-Clause Management ---

export const addClauseToTopic = async (
    topicId: number,
    clauseCreate: ITopicClauseCreate
) => {
    const result = await axios.post<ITopicClause>(
        `${API}/${topicId}/clauses`,
        clauseCreate
    );
    return result.data;
};

export const addClausesBulkToTopic = async (
    topicId: number,
    bulkCreate: ITopicClauseBulkCreate
) => {
    const result = await axios.post<ITopicClauseBulkCreateResponse>(
        `${API}/${topicId}/clauses/bulk`,
        bulkCreate
    );
    return result.data;
};

export const removeClauseFromTopic = async (
    topicId: number,
    topicClauseId: number
) => {
    const result = await axios.delete(
        `${API}/${topicId}/clauses/${topicClauseId}`
    );
    return result.data;
};

export const getClausesForTopic = async (
    topicId: number,
    page: number = 1,
    size: number = 50,
    filter?: ITopicClauseFilter
) => {
    const url = buildUrl(`${API}/${topicId}/clauses`, {
        page,
        size,
        ...filter,
    });
    const result = await axios.get<Page<ITopicClause>>(url);
    return result.data;
};

// --- Topic Import/Export ---

export const exportTopics = async () => {
    const result = await axios.get(`${API}/export`, {
        responseType: "blob",
    });
    return result.data;
};

export const bulkImportTopics = async (
    objectName: string,
    preprocessOnly: boolean = false
) => {
    const result = await axios.post<ITopicImportStats>(
        `${API}/import/${objectName}?preprocess_only=${preprocessOnly}`
    );
    return result.data;
};
